import { useAuthContext } from "./AuthContext";
import { PortalAccess } from "../types/user";

export interface AuthUser {
  email:         string;
  role:          "admin" | "reviewer" | "viewer";
  name:          string;
  portal_access: PortalAccess;
  is_active:     boolean;
}

const FALLBACK_USER: AuthUser = {
  email:         "",
  role:          "reviewer",
  name:          "",
  portal_access: "find_your_ohio",
  is_active:     true,
};

export function useAuth(): AuthUser {
  const { user } = useAuthContext();
  return user ?? FALLBACK_USER;
}
